import { render, staticRenderFns } from "./BBS901P03.vue?vue&type=template&id=8cf91d56&"
import script from "./BBS901P03.vue?vue&type=script&lang=js&"
export * from "./BBS901P03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports